import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { gallery } 		from './theme/components/gallery.js';
import { map } 			from './theme/components/map.js';
import { colsimage } 	from './theme/components/colsimage.js';
import { subpage } 		from './theme/components/subpage.js';
import { modal } 		from './theme/components/modal.js';

AOS.init();

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();

		self.loadFancy();
		self.touch();

		self.inlineYoutube();

		self.lazyVideo();

		self.viewMoreText();

		modal.init();
		hamburger.init();
		subpage.init();
		
		self.refresh();
	},

	getHighestResImg: function( srcset ){
        if(srcset){
            let highResImgUrl = '';
            let maxRes = 0;
            let imgWidth,urlWidthArr;

            srcset.split(',').forEach((item)=>{
                urlWidthArr = item.trim().split(' ');
                imgWidth = parseInt(urlWidthArr[1]);
                if(imgWidth > maxRes) {
                    maxRes = imgWidth;
                    highResImgUrl = urlWidthArr[0];
                }
            });

            return highResImgUrl;
        } else{
          return  element.getAttribute('src');
        }
    },

	lazyVideo: function () {
		jQuery('source[data-src]').each(function(){
			var sourceFile = jQuery( this ).attr('data-src');
			jQuery(this).attr('src', sourceFile);

			var videoElement = jQuery(this).parent().get(0);
			if (!videoElement.playing) {
				videoElement.load();
				videoElement.play();
			}

			jQuery(this).removeAttr('data-src', sourceFile);
		});
    },

	refresh: function( force = false ) {
		var self = this;

		gallery.init();

		setTimeout(function () {
			colsimage.init();

			setTimeout(function () {
				self.lazyVideo();
			}, 10);
		}, 500);

		jQuery( '.big-navigation' ).removeClass( 'big-navigation--animate' );
 
		self.markEmptyParagraphs();
		self.tilesSlider();

		self.floatingInputLabel();
		self.heroWatch();

		map.init();
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	tableWrap: function () {
		if( jQuery( '.text-content table' ).length ) {
			jQuery( '.text-content table' ).wrap( '<div class="responsTable"></div>' )
		}
	},

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},

	heroWatch: function(){
		var self = this;

		jQuery( '.hero__watch' ).hover(function(){
			jQuery( this ).removeClass( 'done-hover' );
			jQuery( this ).addClass( 'is-hover' );
		}, function(){
			var button = jQuery( this );

			button.addClass( 'done-hover' );
			button.removeClass( 'is-hover' );

			setTimeout( function() {
				button.removeClass( 'done-hover' );
			}, 8000 );
		});

		jQuery( '[youtubeid]' ).grtyoutube();
	},
	tilesSlider: function () {
		
		if( jQuery(".js-tilesSlider").length ) {

			var svgIcon = '<svg height="24" viewBox="0 0 6.3499999 6.3500002" width="24" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg"><g id="layer1" transform="translate(0 -290.65)"><path id="path9429" d="m2.2580394 291.96502a.26460982.26460982 0 0 0 -.1741496.46871l1.6190225 1.38699-1.6190225 1.38648a.26460982.26460982 0 1 0 .3436483.40049l1.8536335-1.58595a.26460982.26460982 0 0 0 0-.40256l-1.8536335-1.5875a.26460982.26460982 0 0 0 -.1694987-.0667z" font-variant-ligatures="normal" font-variant-position="normal" font-variant-caps="normal" font-variant-numeric="normal" font-variant-alternates="normal" font-feature-settings="normal" text-indent="0" text-align="start" text-decoration-line="none" text-decoration-style="solid" text-decoration-color="rgb(0,0,0)" text-transform="none" text-orientation="mixed" white-space="normal" shape-padding="0" isolation="auto" mix-blend-mode="normal" solid-color="rgb(0,0,0)" solid-opacity="1" vector-effect="none"/></g></svg>';

			jQuery('.js-tilesSlider').not( '.slick-initialized' ).slick({
				center: false,
				infinite: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				speed: 400,
				arrows: true,
				prevArrow: `<button type='button' class='slick-prev pull-left'>${svgIcon}</button>`,
            	nextArrow: `<button type='button' class='slick-next pull-right'>${svgIcon}</button>`,
				mobileFirst: true,
				dots: false,
				swipeToSlide: true,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3,
						}
					},
					{
						breakpoint: 544,
						settings: {
							slidesToShow: 2,
						}
					},
					{
						breakpoint: 0,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		}
	},

	loadFancy: function() {
		var self = this;
		
		if( ! jQuery( '.stats__one img' ).length ) {
			return;
		}

		// jQuery( 'p a[rel="noopener"]' ).has("img").fancybox(); class="fancybox" data-fancybox="gallery"
		jQuery( '.stats' ).each(function(){
			jQuery(this).find( '.stats__one img' ).each(function(){
				var attr = jQuery(this).attr('srcset');

				if (typeof attr !== 'undefined' && attr !== false) {
					var href = self.getHighestResImg( jQuery( this ).attr( 'srcset' ) );
					var html = jQuery( this ).html();

					jQuery( this ).wrap( '<a href="'+ href +'" data-fancybox="gallery">'+ html +'</a>' );
				}
			});
		});
	},

	uniqueId: function(){
		return "block-id-" + Math.random().toString(16).slice(2);
	},

	roundText: function () {
		if( jQuery("#cirleText").length ) {
			const circleType = new CircleType( document.getElementById('cirleText') );
			circleType.radius( 54 );

			setTimeout( function() {
				var height = jQuery( '.hero__watch__round > div' ).css( 'height' );
				jQuery( '.hero__watch__round > div' ).css( 'width', 'calc( '+ height +' + 1px )' );
			}, 100 );
		}
	},
	
	floatingInputLabel: function () {
			jQuery( ".js-floatLabelInput" ).each(function( ) {
			  if(jQuery(this).val() != "") {
			  	jQuery(this).addClass( "activeLabel" );
			  	jQuery(this).closest(".wpcf7-column").find("label").addClass("active");
			  }
			});
		  
		  jQuery( ".js-floatLabelInput" ).focus( function() {
			jQuery(this).addClass( "activeLabel" );
			jQuery(this).closest(".wpcf7-column").find("label").addClass("active");
		  });
		  
		  jQuery( ".js-floatLabelInput" ).focusout( function() {
			if( jQuery(this).val() == '' ) {
				jQuery(this).removeClass( "activeLabel" );
				jQuery(this).closest(".wpcf7-column").find("label").removeClass("active");
			}
		  });
	},
	
	markEmptyParagraphs: function () {
		jQuery("p").each(function(){
			var $this = $(this);
			if( $this.html() == '&nbsp;' ) {
				$this.addClass("empty-paragraph");
			}
		});
	},

	viewMoreText: function () {
		jQuery( '.show-fulltext' ).on( 'click', function( event ){
			event.preventDefault();

			jQuery( this ).parent().addClass( 'view-all' );
		});
	},

	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: 0,
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	inlineYoutube: function () {
		jQuery( document ).on( "click", ".youtube-player" , function() {
			var video_id = jQuery( this ).data("youtube");
			jQuery( this ).addClass('played');
			jQuery( this ).html('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video_id + '?autoplay=1&mute=0&rel=0&" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe');

		});
	},
	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
	},
	onscroll(position, previusPosition) {
		var self = this;
	},
};

jQuery(document).ready(function ($) {
	theme.init();
	colsimage.scrollCheck();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
	colsimage.scrollCheck();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
	colsimage.scrollCheck();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};